/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreEntitiesWinConditionTypeSchema = z.enum([
  "Kill",
  "CreepScore100",
  "TowerDestroyed",
]);
